import React from 'react';
import PropTypes from 'prop-types';
import './css/ProgressBar.css';

function ProgressBar(props) {
  const { progress } = props;
  return (
    <div className="prg_bar_track">
      <div
        className="prg_bar_progress"
        style={{
          width: `${progress}%`,
        }}
      />
    </div>
  );
}

ProgressBar.propTypes = {
  progress: PropTypes.number.isRequired,
};

export default ProgressBar;
